// manually pollyfilling due to awkwardness with Lambda and rollup.
var values = typeof Object.values === 'function' ? Object.values : obj => Object.keys(obj).map(key => obj[key]);
export default values;